// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aM-z","twoColumnImage":"bM-z"};